import React, { useCallback, useEffect, useState } from "react";
import "./index.scss";
import Modal from "./Modal";
import { Row, Col, Image, OverlayTrigger, Popover } from "react-bootstrap";
import { useSelector } from "react-redux";
import { BASE_URL } from "constants/routes";
import ImageUploaded from "../../assets/images/image_uploaded.svg";
import OtherFile from "../../assets/images/otherFile.svg";
import VerifyLogo from "../../assets/images/verify_logo.svg";
import { LazyImage } from "helper/LazyImage";
import { verification_response } from "constants/docVerification";

const DocumentViewer = (props) => {
  const {
    label: document_label,
    size,
    selectedData,
    name: document_name,
    isMapper,
    documentData,
    form_field_items,
    classNameOrMargin,
    recursive_section,
    recursive_Data,
    show_verified_icon,
    verify_details,
    custom_styles,
    custom_value,
    face_match_document,
    is_payment_document,
    use_original_name
  } = props;
  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );

  const activeNavTab = useSelector(
    (state) => state?.dashboardDetailReducer?.activeNavTab
  );
  const currentSubWorkFlowInfo = useSelector((state) => state?.dashboardDetailReducer?.userSubworkFlowInfo);
  let face_match = currentSubWorkFlowInfo?.face_match_percenatge
  
  const payment_details = useSelector((state) => state.paymentReducer?.payment_details);

  let imgObject = {};
  let imageUrl = "";
  let downloadUrl = "";
  let isPdf = false;
  let isOtherFile = false;
  let acceptedFiles = [".jpg",".jpeg",".png",".pdf"];
  const label = isMapper ? documentData?.field_label : document_label;
  let name = isMapper ? documentData?.field_label : document_name;
  const [verifyIcon, setVerifyIcon] = useState(false);
  const [popoverData, setPopoverData] = useState("");
  const [showModal, setShowModal] = useState(false);

  if (name) {
    if (isMapper) {
      imgObject = documentData || {};
    } else if (recursive_section) {
      imgObject = recursive_Data[name];
    } else {
      imgObject =
        selectedData?.documents && selectedData?.documents.hasOwnProperty(name)
          ? selectedData?.documents[name]
          : selectedData?.[name] || {};
    }
    if (custom_value) {
      imageUrl = eval(custom_value);
    }
    if(is_payment_document){
      if (imgObject?.encrypted_filename) {
        imageUrl = `${BASE_URL}/workflow/previewPaymentUploadedDocument/${selectedData?.organisation_id}/${payment_details?._id}/${imgObject?.encrypted_filename}/${imgObject?.original_filename}`;
        downloadUrl = `${BASE_URL}/workflow/downloadPaymentDocument/${selectedData?.organisation_id}/${payment_details?._id}/${imgObject?.encrypted_filename}/${imgObject?.original_filename}`;
        var extension = imgObject?.document_type;
        if (imgObject?.document_type) {
          extension = extension.toLowerCase();
        }
        if (extension === ".pdf") {
          isPdf = true;
        } else if (!acceptedFiles.includes(extension)) {
          isOtherFile = true;
        }
      }
    }
    else if (
      imgObject?.encrypted_filename &&
      currentSubWorkFlowId &&
      !recursive_section
    ) {
      imageUrl = `${BASE_URL}/workflow/viewUploadedDocument/${currentSubWorkFlowId}/${name}/${
        imgObject?.encrypted_filename
      }${isMapper ? `/${form_field_items}` : ""}`;
      downloadUrl = `${BASE_URL}/workflow/downloadDocument/${currentSubWorkFlowId}/${name}/${
        imgObject?.encrypted_filename
      }${isMapper ? `/${form_field_items}` : ""}`;
      var extension = imgObject?.document_type;
      if (imgObject?.document_type) {
        extension = extension.toLowerCase();
      }
      if (extension === ".pdf") {
        isPdf = true;
      } else if (!acceptedFiles.includes(extension)) {
        isOtherFile = true;
      }
    } else if (
      recursive_section &&
      imgObject?.encrypted_filename &&
      currentSubWorkFlowId
    ) {
      imageUrl = `${BASE_URL}/workflow/viewRecursiveUploadedDocument/${currentSubWorkFlowId}/${name}/${
        imgObject?.encrypted_filename
      }/${imgObject?.original_name}/${selectedData?.organisation_id}${
        isMapper ? `/${form_field_items}` : ""
      }`;
      downloadUrl = `${BASE_URL}/workflow/downloadRecursiveDocument/${currentSubWorkFlowId}/${name}/${
        imgObject?.encrypted_filename
      }/${imgObject?.original_name}/${selectedData?.organisation_id}${
        isMapper ? `/${form_field_items}` : ""
      }`;
      var extension = imgObject?.document_type;
      if (extension) {
        extension = extension.toLowerCase();
      }
      if (extension === ".pdf") {
        isPdf = true;
      } else if (!acceptedFiles.includes(extension)) {
        isOtherFile = true;
      }
    }
  }


  const handleClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const chooseColorCode = (value) => {
    if (parseInt(value) >= 85) {
      return "greenColour";
    } else if (parseInt(value) >= 50) {
      return "yellowColour";
    } else {
      return "redColour";
    }
  };
  const chooseColor = (value) => {
    if (parseInt(value) > 85) {
      return "#92ce6a";
    } else if (parseInt(value) > 60) {
      return "#e89200";
    } else {
      return "#ff6464";
    }
  };


  const popover = (
    <Popover id="popover-trigger-hover-focus" className="d-none d-md-none d-lg-block"  style={{
      backgroundColor: "#4D4D4D",
    }}>
      {popoverData && (
        <div  style={{
          padding: "10px"
        }}>
          {!verify_details && currentSubWorkFlowInfo?.verification_response ? Object.entries(verification_response[`${popoverData}`]).map((_item) => {
            let newKey = _item[0].split("_").join(" ");
            let value = _item[1];
            return (
              <div style={{
                display: "flex",
                flexDirection: "row"
              }}>
                <div>
                  <span style={{
                    color: "#B0B0B9",
                    fontSize: "13px",
                    textAlign: "left",
                    fontWeight: "bolder"
                  }}>{newKey} : </span>
                </div>
                <div>
                  <span style={{
                    color: "#fff",
                    fontSize: "13px",
                    fontWeight: "bolder",
                    textAlign: "right"
                  }}>&nbsp; {`${currentSubWorkFlowInfo?.verification_response[`${name}`][`${value}`]}`}</span>
                </div>
              </div>
            )
          }) : currentSubWorkFlowInfo?.verification_response && Object.entries(verify_details).map((item) => {
            let newKey = item[0].split("_").join(" ");
            let value = item[1];
            return (
              <div style={{
                display: "flex",
                flexDirection: "row"
              }}>
                   {currentSubWorkFlowInfo?.verification_response?.[`${name}`]?.[`${value}`] ? (
                  <>
                    <div>
                      <span style={{
                        color: "#B0B0B9",
                        fontSize: "13px",
                        textAlign: "left",
                        fontWeight: "bolder"
                      }}>{newKey} : </span>
                    </div>
                    <div>
                      <span style={{
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        textAlign: "right"
                      }}>&nbsp; {currentSubWorkFlowInfo?.verification_response[`${name}`][`${value}`] ? `${currentSubWorkFlowInfo?.verification_response[`${name}`][`${value}`]}` : ""}</span>
                    </div>
                  </>
                ) : null}
              </div>
            )
          })}
        </div>
      )}
    </Popover>
  );

  useEffect(() => {
    if (show_verified_icon && currentSubWorkFlowInfo?.verification_response) {
      if (currentSubWorkFlowInfo?.verification_response[`${name}`]?.is_verify) {
        setVerifyIcon(true);
        if (verify_details) {
          setPopoverData(verify_details);
        } else if (verification_response) {
          Object.keys(verification_response).map((item) => {
            if (item === name) {
              setPopoverData(item);
            }
          })
        }
      }
    }
  }, [show_verified_icon, verification_response, currentSubWorkFlowInfo])

  return (
    <>
      {imageUrl && custom_value && (
        <div className={`gy-3 document_viewer ${custom_styles}`}>
          <div className={`${size} ${classNameOrMargin}`}>
          <Row
            className="bg-light border rounded-2 py-3 mx-md-0"
            onClick={handleClick}
          >
            <Col lg={6} sm={6} xs={8} className="d-flex align-items-center">
              <strong title={`${label}`} className="document_viewer_label">{label}</strong>
            </Col>
            <Col lg={6} sm={6} xs={4}>
                              <div className="d-flex justify-content-end">
                              {custom_value && (
                <LazyImage
                  activeNavTab={activeNavTab}
                  setShowModal={setShowModal}
                  src={ImageUploaded}
                  className="lazyLoaderImage"
                />
              )}
                              </div>
                          </Col>
          </Row>
          </div>
          {showModal && custom_value && (
            <Modal
              show={true}
              imgSrc={imageUrl}
              setShowModal={setShowModal}
              isPdf={true}
              custom_value={custom_value}
            />
          )}
          </div>
      )}
      {imageUrl && !custom_value && (
        !verifyIcon && !face_match_document ? (
          <div className={`gy-3 document_viewer ${custom_styles}`}>
           <div className={`${size} ${classNameOrMargin}`}>
           <Row
              className="bg-light border rounded-2 py-3 mx-md-0"
              onClick={handleClick}
            >
              <Col lg={9} md={9} xs={8} className="d-flex align-items-center">
                <strong title={`${label}`} className="document_viewer_label fs-14px">{label}</strong>
              </Col>
              <Col lg={3} md={3} xs={4}>
                              <div className="d-flex justify-content-end">
                                  <LazyImage
                                      activeNavTab={activeNavTab}
                                      setShowModal={setShowModal}
                                      src={isPdf ? ImageUploaded : isOtherFile ? OtherFile : imageUrl}
                                  />
                              </div>
                          </Col>
            </Row>
           </div>
            {showModal && (
              <Modal
                show={true}
                imgSrc={imageUrl}
                setShowModal={setShowModal}
                isPdf={isPdf}
                isOtherFile = {isOtherFile}
                downloadUrl={downloadUrl}
              />
            )}
          </div>
        ) : (
          face_match_document ? (
            <div className={`gy-3 ${size} ${classNameOrMargin}`}>
              <Row
                className="document_viewer_container onMobileShowSizeToThis mt-4"
                onClick={handleClick}
              >

                <Col
                  lg={4}
                  sm={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    height: "inherit",
                  }}
                >
                  <LazyImage
                    activeNavTab={activeNavTab}
                    setShowModal={setShowModal}
                    src={isPdf ? ImageUploaded : isOtherFile ? OtherFile : imageUrl}
                    className="lazyLoaderImage"
                  />
                </Col>
                <Col lg={7} sm={12} className=" d-flex flex-column p-0">
                  <strong title={`${label}`} 
                  className="document_viewer_label"
                  style={{fontSize:"16px",
                  color:"#3D415B"}}>{label}</strong>
                  <div className="mb-3">
                  <div
                    style={{
                      justifyContent: "space-between",
                    }}
                    className="d-flex mt-1"
                  >
                    <span className="fontFamily matchtext ">
                      {(face_match)
                        ? "Average Face Match"
                        : "Average Face Match"}
                    </span>
                    <span

                      className={`fontFamily matchtext ${chooseColorCode(
                        face_match
                      )}`}
                    >
                      {face_match}%
                    </span>
                  </div>
                  <div className="slider">
                    <div
                      className={`slider-fill ${chooseColorCode(
                        face_match
                      )}`}
                      style={{
                        backgroundColor: `${chooseColor(
                          face_match
                        )}`,
                        width: `${face_match
                          }%`,
                        
                      }}
                    ></div>
                  </div>
                  </div>
                </Col>

              </Row>
              {showModal && (
                <Modal
                  show={true}
                  imgSrc={imageUrl}
                  setShowModal={setShowModal}
                  isPdf={isPdf}
                  isOtherFile={isOtherFile}
                  downloadUrl={downloadUrl}
                />
              )}
            </div>
          ) : (
            <div className={`gy-3 document_viewer_verified ${custom_styles}`}>
             <div className={` ${size} ${classNameOrMargin}`}>
             <Row
                className="bg-light border rounded-2 py-3 mx-md-0 "
                onClick={handleClick}
              >
       
                <Col lg={9} md={9} xs={9} className="d-flex align-items-center">
                  <strong title={`${label}`} className="document_viewer_label_verified">{label}</strong>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  xs={3}
                  className="position-relative text-end"
                >
                  <LazyImage
                    activeNavTab={activeNavTab}
                    setShowModal={setShowModal}
                    src={isPdf ? ImageUploaded : isOtherFile ? OtherFile : imageUrl}
                    className="lazyLoaderImageVerified"
                  />
                           <div class="position-absolute top-0 end-0">
                  <OverlayTrigger
                    trigger={['hover', 'focus', 'click']}
                    placement="top-end"
                    overlay={popover}
                  >
                    {/* <img src={VerifyLogo}/> */}
                    <div className="verify_icon me-3">
                      <div className="verified_text">
                        Validated
                      </div>
                    </div>
                  </OverlayTrigger>
                </div>
                </Col>
              </Row>
             </div>
              {showModal && (
                <Modal
                  show={true}
                  imgSrc={imageUrl}
                  setShowModal={setShowModal}
                  isPdf={isPdf}
                  isOtherFile={isOtherFile}
                  downloadUrl={downloadUrl}
                />
              )}
            </div>
          )
        )
      )}
    </>
  );
};

export default DocumentViewer;